import { render } from "./SupervisorAutoComplete.vue?vue&type=template&id=5ee3ae42"
import script from "./SupervisorAutoComplete.vue?vue&type=script&lang=js"
export * from "./SupervisorAutoComplete.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__